import { KeyConceptComponent } from './../key-concept/key-concept.component';
import { Component, ElementRef, ChangeDetectorRef, HostListener, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faEllipsisV, faEarthAsia, faSearch, faBars, faEdit, faL } from '@fortawesome/free-solid-svg-icons';
import { UserGroupService } from 'src/app/core/services/user-group/user-group.service';
import { catchError } from 'rxjs/operators';
import { of, filter, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';

@Component({
    selector: 'app-admin-usergroup',
    templateUrl: './admin-usergroup.component.html',
    styleUrls: ['./admin-usergroup.component.scss'],
})
export class AdminUsergroupComponent {
    searchText = '';
    userGroupnameText = '';
    descriptionText = '';
    showDropdown = false;
    highlighted: string = '';
    faEllipsisV = faEllipsisV;
    currentPage: number = 1; // Current page
    itemsPerPage = 10; // Items per page
    totalItems: any; // Total items
    totalPages: any; // Total pages
    clients: any;
    pageNumber = {
        page: 1,
    };
    disableForm = true;
    filteredClients = []; // Clients filtered based on search

    filteredClientsForm = [];
    searchTerm: string = ''; // For two-way binding with search bar

    isDropdownOpen: boolean = false; // Controls dropdown visibility
    searchIdsForUserGroupData: any;
    // selectedClient: string | null = null; // Selected clientselectedClients: string[] = []; // List of selected clients
    // selectedClient: string = ''; // Selected client
    selectedClient: string | null = null; // Stores the selected client
    clientsList = [];
    // showDropdown: boolean = false; // Dropdown visibility
    showcreateandEditForm = false;
    clientList = ['Test Client 1', 'Test Client 2', 'Client Alpha', 'Client Beta', 'Client Gamma']; // Client list
    userGroups: any;
    roles: any;
    // accessOptions = ['Access1', 'Access2', 'Access3', 'Access4'];
    pageSize = 5;
    searchListArray: any;
    userGroupForm: any;
    options: any;
    // options = ['Option 1', 'Option 2', 'Option 3', 'Option 4'];
    selectedOptions: any;

    multifilteredClients: any;
    multiclients: any;
    multisearchTerm: string = '';
    multiisDropdownOpen: boolean = false;
    multiselectedClient: string = '';
    // multiselectedClients :any[] = [];
    // multiselectedClients :any; // Properly typed and initialized
    multiselectedClients: any = []; // Properly typed and initialized
    keepDropdownOpen: boolean = false; // Prevent dropdown from closing on interaction
    selectedRole = '';
    selectedIds: any;
    disableSubmit = false;
    usergroupId: any;
    isMobile = false;

    selectedClientCountText = '#count# Client(s) Selected';
    selectedAccessCountText = '#count# Access(s) Selected';
    selectedAccessBlankText = 'Select';
    selectedClientBlankText = 'Select';
    activeAccessList: number | null = null;
    private createUserGroupForClient: Subscription;
    isLoadingData = true;
    errors: { [key: string]: string } = {};

    onToggle(option: any, value: any) {
        const index = this.selectedOptions.indexOf(option);
        if (value.target.checked) {
            option.isSelected = true;
        } else {
            option.isSelected = false;
        }
        console.log('option 1 2 3 4', option, value);
        if (index > -1) {
            // If the option is already selected, remove it
            this.selectedOptions.splice(index, 1);
        } else {
            // Otherwise, add it
            this.selectedOptions.push(option);
        }

        this.selectedIds = this.selectedOptions.map((option: { id: any }) => option.id);
        console.log('this.selectedOptions are', option, JSON.stringify(this.selectedOptions), this.selectedIds);
    }

    getSelectedOptions() {
        console.log('selectedOptions are selectedOptions', this.selectedOptions);
        if (this.selectedOptions?.length > 0) {
            // Join the selected options with a comma separator
            return this.selectedOptions.map((option: { name: any }) => option.name);
        } else {
            return 'Select';
        }
    }

    clearSearch() {
        this.searchText = ''; // Clear the search input
        this.callandRefreshusergroup();
    }

    clearSelection(): void {
        this.selectedClient = null;
        this.searchTerm = ''; // Reset the input value
        this.filteredClients = []; // Clear filtered clients
        this.clientSearchList();
    }

    onSearchTextChange() {
        if (this.searchText == '') {
            this.callandRefreshusergroup();
        }
    }

    activePopupIndex: number | null = null;
    toggleList(index: number, event: Event) {
        event.stopPropagation();
        if (this.activeAccessList === index) {
            // Close the "Access" popup
            this.activeAccessList = null;
        } else {
            // Open the "Access" popup and close the "Actions" popup
            this.activeAccessList = index;
            this.activePopupIndex = null;
        }
    }

    // Toggles the "Actions" popup
    togglePopup(index: number, event: Event): void {
        event.stopPropagation();
        if (this.activePopupIndex === index) {
            // Close the "Actions" popup
            this.activePopupIndex = null;
        } else {
            // Open the "Actions" popup and close the "Access" popup
            this.activePopupIndex = index;
            this.activeAccessList = null;
        }
    }

    // Close all popups when clicking outside
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        this.activePopupIndex = null;
        this.activeAccessList = null;
    }

    restrictInput(event: KeyboardEvent): void {
        const allowedCharacters = /^[a-zA-Z0-9-_ ]*$/;
        const inputChar = event.key;

        if (!allowedCharacters.test(inputChar)) {
            event.preventDefault(); // Block the keypress
        }
    }

    editGroup(group: any, modal: TemplateRef<any>) {
        this.modalService.open(modal, { size: 'sm', windowClass: 'custom-modal-class-userGroup', backdrop: 'static', keyboard: false });
        this.disableForm = true;
        console.log('Edited item is', group);
        this.showcreateandEditForm = true;
        this.userGroupnameText = group.name;
        this.descriptionText = group.label;
        this.searchTerm = group.clientName;
        this.selectedRole = group.userGroupType;
        this.usergroupId = group.userGroupId;
        this.selectedClient = group.clientName;

        //call the api based on the selectedRole and populate access data

        const reqBody = {
            userGroupId: group.userGroupId,
            query: null,
            userGroupType: null,
            limit: null,
            offset: 0,
        };
        this.usergroup.getAccessList(reqBody).subscribe((data) => {
            this.options = data.accessList;
            this.selectedAccessItems = this.options.filter((item: { isSelected: any }) => item.isSelected);
            this.selectedOptions = this.options.filter((option: { isSelected: any }) => option.isSelected);
            this.selectedIds = this.selectedAccessItems.map((option: { id: any }) => option.id);

            this.selectedOptions.map((option: { name: any }) => option.name);
        });
        // Add your edit logic here
    }

    deleteGroup(group: any) {
        console.log('Delete:', group);
        // Add your delete logic here
    }
    // filteredClients:any;
    constructor(
        private fb: FormBuilder,
        private cd: ChangeDetectorRef,
        private usergroup: UserGroupService,
        private toast: ToastrService,
        private eRef: ElementRef,
        private modalService: NgbModal,
        private route: ActivatedRoute,
        private router: Router,
        private commonservice: CommonServiceService,
    ) {
        this.createUserGroupForClient = this.commonservice.createUserGroupForClient$.subscribe((data) => {
            if (data?.createnew) {
                console.log('the value for createUserGroupForClient is', data.data.name);
                setTimeout(() => {
                    this.createButton?.nativeElement?.click();
                    this.selectedClient = data.data.name;
                    this.searchTerm = data.data.name; // Show the selected value in the input
                }, 0); //
            }
        });
    }

    @ViewChild('createButton', { static: true }) createButton!: ElementRef<HTMLButtonElement>;
    createnew: boolean | null = null;
    ngOnInit() {
        this.checkWidth();
        this.SearchList();
        this.clientSearchList();

        //add a condition for routing through client component

        this.usergroup.usergroupType().subscribe((data) => {
            this.roles = data;
            console.log('the result of usergroupType are', data);
        });
    }

    checkWidth() {
        const width = window.innerWidth;
        console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    clientSearchList() {
        const req = {
            query: '',
            limit: null,
            offset: 0,
            order: 'ASC',
            sortBy: 'ClientName',
        };
        const term = '';
        this.usergroup.getClientList(req).subscribe((data) => {
            this.clientsList = data.clients || [];
            console.log('data.clients are', data.clients);
            this.filteredClients = data.clients.map((client: { name: any }) => client.name).filter((client: string) => client.toLowerCase().includes(term));
        });
    }

    onChangeUserGroup(selectedValue: string) {
        const reqBody = {
            userGroupId: null,
            query: null,
            userGroupType: selectedValue,
            limit: null,
            offset: 0,
        };
        this.usergroup.getAccessList(reqBody).subscribe((data) => {
            console.log('the response of usergroup access is', JSON.stringify(data.accessList));
            this.options = data.accessList;
            this.selectedAccessItems = this.options.filter((item: { isSelected: any }) => item.isSelected);
            this.selectedOptions = this.options.filter((option: { isSelected: any }) => option.isSelected);
            this.selectedIds = this.selectedAccessItems.map((option: { id: any }) => option.id);
            this.validateField('selectedAccessItems');
        });
        console.log('this.userGroupForm.value', this.userGroupnameText, this.descriptionText, this.selectedClient, selectedValue);
    }

    blurDropdown(event: FocusEvent): void {
        setTimeout(() => {
            if (!(event.relatedTarget as HTMLElement)?.classList.contains('dropdown-item')) {
                this.showDropdown = false;
            }
        }, 150); // Allow dropdown interaction
    }

    get paginatedGroups() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.userGroups.slice(start, end);
    }

    onAction(group: any) {
        console.log('Action clicked for:', group);
    }

    // Handle dropdown change event
    onClientChange(event: Event): void {
        const selectedValue: string = (event.target as HTMLSelectElement).value;
        console.log('Selected Client:', selectedValue);
    }

    onSelect(searchStr: string) {
        console.log('the selected string is', searchStr);
    }
    onFocus() {
        this.showDropdown = true;
    }

    // Get start and end item indices for the current page
    get startItem(): number {
        return (this.currentPage - 1) * this.itemsPerPage + 1;
    }

    get endItem(): number {
        const endItem = this.currentPage * this.itemsPerPage;
        return endItem > this.totalItems ? this.totalItems : endItem;
    }

    // Navigate to the previous page
    prevPage(): void {
        if (this.currentPage > 1) {
            this.currentPage--;
        }
    }

    // Navigate to the next page
    nextPage(): void {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
        }
    }

    checkvalidation() {}

    openUserGroupCreationForm(modal: TemplateRef<any>) {
        this.modalService.open(modal, { size: 'sm', windowClass: 'custom-modal-class-userGroup', backdrop: 'static', keyboard: false });
        this.errors = {};
        this.userGroupnameText = '';
        this.descriptionText = '';
        this.selectedRole = '';
        this.selectedIds = [];
        this.selectedOptions = [];
        this.selectedAccessItems = [];
        this.disableForm = false;
        this.selectedClient = '';
        this.searchTerm = '';
        console.log('the form is opened');
        this.showcreateandEditForm = true;
        this.filterClients();
    }

    closeCreateandEditForm() {
        this.showcreateandEditForm = false;
        this.modalService.dismissAll();
    }

    onSubmit(): void {
        if (this.userGroupForm.valid) {
            console.log('Form Data:', this.userGroupForm.value);
        }
    }

    // Filter the clients based on user input
    filterClients(): void {
        console.log('this.searchTerm is', this.searchTerm);
        const term = this.searchTerm.toLowerCase();
        const req = {
            query: term,
            limit: null,
            offset: 0,
            order: 'ASC',
            sortBy: 'ClientName',
        };
        this.usergroup.getClientList(req).subscribe((data) => {
            this.clients = data.clients;
            console.log('the response of usergroup clientlist is', data);
            this.filteredClients = this.clients.map((client: { name: any }) => client.name).filter((client: string) => client.toLowerCase().includes(term));
        });

        console.log('filteredClients are', this.filteredClients);
    }

    // Open the dropdown when input is focused
    toggleDropdown(open: boolean): void {
        this.isDropdownOpen = open;
    }

    // Hide dropdown on blur after a delay to allow mousedown events
    hideDropdown(): void {
        setTimeout(() => {
            this.isDropdownOpen = false;
        }, 200);
    }

    // Select a client and update the search term
    selectClient(client: string): void {
        this.selectedClient = client;
        this.searchTerm = client; // Show the selected value in the input
        this.isDropdownOpen = false; // Close the dropdown
        console.log('Selected Client:', client);
    }

    multiselectClient(client: any): void {
        this.multiselectedClients = client;
        this.multisearchTerm = client; // Show the selected value in the input
        this.multiisDropdownOpen = false; // Close the dropdown
        console.log('Selected Client:', client);
    }

    multihideDropdown(): void {
        setTimeout(() => {
            this.multiisDropdownOpen = false;
        }, 200);
    }

    handleBlur() {
        setTimeout(() => {
            if (!this.keepDropdownOpen) {
                this.multiisDropdownOpen = false;
            }
            this.keepDropdownOpen = false;
        }, 200); // Delay to allow checkbox click to register
    }

    createNewUserGroup() {
        console.log(' this.usergroupId ', this.usergroupId);
        const request = {
            groupId: this.disableForm ? this.usergroupId : null,
            userGroupName: this.userGroupnameText.trim(),
            label: this.descriptionText.trim(),
            clientName: this.searchTerm,
            userGroupType: this.selectedRole,
            accessIds: this.selectedIds,
        };

        this.selectedClient = this.searchTerm;
        // this.usergroup.createandupdate(request).subscribe((data)=> {
        console.log('the response of usergroup create and update is', request);
        // })
        if (this.userGroupnameText !== '' && this.selectedClient != '' && this.selectedRole != '' && this.selectedIds.length != 0) {
            this.usergroup
                .createandupdate(request)
                .pipe(
                    catchError((error) => {
                        if (error.status === 500) {
                            // Handle 500 error specifically
                            console.error('Server error occurred:', error.error.message);
                            this.toast.warning(error.error.message);
                        } else {
                            // Handle other errors
                            console.error('An error occurred:', error);
                        }
                        // Return an empty observable so the app doesn't break
                        return of(null);
                    }),
                )
                .subscribe((data) => {
                    if (data) {
                        // API response is successful, handle the data
                        this.toast.success(data.message);
                        this.showcreateandEditForm = false;
                        this.modalService.dismissAll();
                        this.searchText = '';
                        this.searchIdsForUserGroupData = [];
                        this.selectedClientItems = [];
                        this.callandRefreshusergroup();
                    }
                });
        }
    }
    callandRefreshusergroup() {
        console.log('this is called first - 2');
        // this.pageNumber = {
        //     page: 1,
        // };
        this.currentPage = 1;
        // const offset = (this.pageNumber.page - 1) * this.itemsPerPage;
        // const limit = this.pageNumber.page === this.totalPages ? this.totalItems - offset : this.itemsPerPage;
        console.log('called here');
        const reqBody = {
            clientIds: this.searchIdsForUserGroupData,
            query: this.searchText,
            limit: 10,
            offset: 0,
            order: 'DESC',
            sortBy: 'UserGroupId',
        };
        this.usergroup.displayUsergroupList(reqBody).subscribe((data) => {
            console.log('called here API');
            this.totalItems = data.totalCount;
            this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
            this.userGroups = data.userGroups;
            this.userGroups.forEach((group: { accessNames: any; accessList: any }) => {
                if (group.accessList.length > 0) group.accessNames = group.accessList.map((access: { label: any }) => access.label).join(', ');
                else group.accessNames = 'No access found';
                group.accessList = group.accessList;
            });
        });
    }

    selectedClientItems: Array<any> = [];
    onSelectionClientChange(selectedItems: Array<any>) {
        this.selectedClientItems = selectedItems;

        // Extract IDs of selected items
        const selectedIds = selectedItems.map((item) => item.id);
        console.log('Selected Client IDs:', selectedIds);
        this.searchIdsForUserGroupData = selectedIds;
        if (this.searchIdsForUserGroupData.length == 0) this.callandRefreshusergroup();
        else this.SearchList();
    }

    selectedAccessItems: any;
    onSelectionAccessChange(selectedItems: Array<any>) {
        this.selectedAccessItems = selectedItems;
        this.validateField('selectedAccessItems');
        console.log('selectedAccessItems are', this.selectedAccessItems);
        this.selectedAccessItems.forEach((element: { isSelected: boolean }) => {
            element.isSelected = true;
        });
        const selectedIds = selectedItems.map((item) => item.id);
        this.selectedIds = selectedIds;
    }

    SearchList() {
        console.log('called from here', this.selectedClientItems);
        this.currentPage = 1;
        const offset = (this.pageNumber.page - 1) * this.itemsPerPage;
        const limit = this.pageNumber.page === this.totalPages ? this.totalItems - offset : this.itemsPerPage;

        const reqBody = {
            clientIds: this.searchIdsForUserGroupData,
            query: this.searchText,
            limit: this.searchText == '' ? 10 : limit,
            offset: offset,
            order: 'DESC',
            sortBy: 'UserGroupId',
        };

        this.usergroup.displayUsergroupList(reqBody).subscribe((data) => {
            this.isLoadingData = false;
            this.totalItems = data.totalCount;
            this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
            this.userGroups = data.userGroups;
            // this.searchText = '';
            this.userGroups.forEach((group: { accessNames: any; accessList: any }) => {
                if (group.accessList.length > 0) group.accessNames = group.accessList.map((access: { label: any }) => access.label).join(', ');
                else group.accessNames = 'No access found';
                // group.accessNames = group.accessList.map((access: { label: any }) => access.label).join(', ');
            });
            console.log('the displayUsergroupList result is', this.userGroups);
        });
    }

    onPageChanged(event: any) {
        console.log('this is called first - 1');
        this.pageNumber = event;
        const offset = (this.pageNumber.page - 1) * this.itemsPerPage;
        const limit = this.pageNumber.page === this.totalPages ? this.totalItems - offset : this.itemsPerPage;
        const reqBody = {
            clientIds: [],
            query: this.searchText,
            limit: limit,
            offset: offset,
            order: 'DESC',
            sortBy: 'UserGroupId',
        };
        this.usergroup.displayUsergroupList(reqBody).subscribe((data) => {
            this.userGroups = data.userGroups;
            this.userGroups.forEach((group: { accessNames: any; accessList: any }) => {
                // group.accessNames = group.accessList.map((access: { label: any }) => access.label).join(', ');
                if (group.accessList.length > 0) group.accessNames = group.accessList.map((access: { label: any }) => access.label).join(', ');
                else group.accessNames = 'No access found';
            });
        });

        console.log('the page number is', this.pageNumber);
    }

    multitoggleDropdown(open: boolean): void {
        this.multiisDropdownOpen = open;
    }

    multifilterClients(): void {
        const term = this.multisearchTerm.toLowerCase();
        const req = {
            query: term,
            limit: null,
            offset: 0,
            order: 'ASC',
            sortBy: 'ClientName',
        };

        this.usergroup.getClientList(req).subscribe((data) => {
            this.multiclients = data.clients; // Assuming data.clients is { id, name }[]
            this.multifilteredClients = this.multiclients.filter((client: { name: string }) => client.name.toLowerCase().includes(term));
        });
    }

    toggleClientSelection(client: { id: number; name: string }, event: Event): void {
        console.log('the toggleClientSelection are', client);
        const index = this.multiselectedClients.findIndex((selectedClient: { id: number }) => selectedClient.id === client.id);

        if ((event.target as HTMLInputElement).checked) {
            if (index === -1) {
                this.multiselectedClients.push(client);
            }
        } else {
            if (index !== -1) {
                this.multiselectedClients.splice(index, 1);
            }
        }
        this.searchIdsForUserGroupData = this.multiselectedClients.map((client: { id: any }) => client.id);
        //call the table API data to search based on the selected ID's
        this.SearchList();
        console.log('the final multiselectedClients are', this.multiselectedClients, this.searchIdsForUserGroupData);

        this.updateSearchTerm();
    }

    isSelected(client: { id: number; name: string }): boolean {
        return this.multiselectedClients.some((selectedClient: { id: number }) => selectedClient.id === client.id);
    }

    updateSearchTerm(): void {
        // Display only names in the input
        this.multisearchTerm = this.multiselectedClients.map((client: { name: any }) => client.name).join(', ');
    }

    onBlur(event: FocusEvent): void {
        const relatedTarget = event.relatedTarget as HTMLElement;
        if (!relatedTarget || !relatedTarget.closest('ul')) {
            this.multiisDropdownOpen = false;
        }
    }

    clearFilteredClients() {
        this.multiselectedClients = []; // Clear the selected clients
        this.multisearchTerm = ''; // Clear the search term in the input box
        this.multifilteredClients = []; // Clear the filtered clients list if required
        this.multiisDropdownOpen = false; // Close the dropdown (optional)
        this.searchIdsForUserGroupData = [];
        this.SearchList();
        //call API and load all the data
        this.clientSearchList();
    }

    userGroupSearchTermSearch() {
        if (this.searchText != '') this.SearchList();
    }

    isFormValid(): boolean {
        const userGroupnamePattern = /[a-zA-Z0-9]/;
        return (
            this.userGroupnameText?.trim() && // Check if User Group Name is not empty
            userGroupnamePattern.test(this.userGroupnameText) &&
            this.selectedClient?.trim() && // Check if a Client Name is selected
            this.selectedRole?.trim() && // Check if a User Group Type is selected
            this.selectedAccessItems.some((option: { isSelected: any }) => option.isSelected) // Check if at least one Access option is selected
        );
    }

    validateField(field: string) {
        switch (field) {
            case 'userGroupnameText':
                this.errors[field] = this.userGroupnameText.trim() === '' ? 'User Group Name is required' : '';
                break;
            case 'descriptionText':
                this.errors[field] = this.descriptionText.trim() === '' ? 'Description is required' : '';
                break;
            case 'searchTerm':
                this.errors[field] = !this.selectedClient ? 'Client Name is required' : '';
                break;
            case 'selectedRole':
                this.errors[field] = this.selectedRole === '' ? 'User Group Type is required' : '';
                break;
            case 'selectedAccessItems':
                this.errors[field] = this.selectedAccessItems.length === 0 ? 'At least one access item must be selected' : '';
                break;
        }
    }
}
